module.exports = __webpack_public_path__ + "static/ricepaper.f0a77664.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/background/ricepaper.png
// module id = 1170
// module chunks = 168707334958949